export type PreviewPage = {
  src: string;
  alt: string;
};

export const previewPages: PreviewPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/mQYYqYABGgSkvv7YGDLJQR/PAGINA_3.jpg',
    alt: 'Sample page Distribution Is the Last Link Between the Power System and the User, showing generation, transmission, distribution and utilization',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/cvFqAS62uy4v4e3VLF8eJc/PAGINA_15.jpg',
    alt: 'Sample page on active, reactive and apparent power, explaining the power triangle with formulas and a technical takeaway',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/8JU7zER8jhquMBw9Hq3SWM/PAGINA_24.jpg',
    alt: 'Sample page Two Mains and a Tie Give a Switchboard Two Lives, showing a double-ended main-tie-main arrangement and its operating states',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/8ZQxYCMxMCT2abrEakkmws/PAGINA_33.jpg',
    alt: 'Sample page Read a Single-Line Diagram the Way the Power Flows, a seven-step guide with a technical warning about backfeeds',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/a88xFtXNxL26CLzErD2FY7/PAGINA_50.jpg',
    alt: 'Sample page Power Distribution Fundamentals Field Card, with checklists for the system, key formulas, drawings, earthing and personal safety',
  },
];
